import styles from "../../styles/hairline.module.scss";

export const Hairline = ({ className = "mt-30 mb-30" }) => {
  return <div className={`${styles.hairlineContainer} ${className}`}></div>;
};
